import { Footer } from '@/core/ui/footer'
import { CustomerHeader } from '@/core/ui/header'
import { Error500Content } from './content'

export const Error500 = () => {
  return (
    <div className='flex h-screen flex-col gap-2 px-8 lg:px-24'>
      <CustomerHeader theme='blue' className='my-6' />
      <Error500Content />
      <Footer />
    </div>
  )
}
